import { MessageInstance } from 'antd/es/message/interface'
import { createContext, Dispatch, SetStateAction } from 'react'

export const MessageContext = createContext<{ message: MessageInstance }>(
  {} as { message: MessageInstance }
)

export const ProjectDetailPageContext = createContext<{
  handleClickHeatMap: (index: number) => void
}>({ handleClickHeatMap: () => {} })

export const ProfessorContext = createContext<{
  showProfessorPanel: (key: Models.ProfessorAnalyseModule) => void
  professorRateInfo: Models.RateMap
  changeProfessorRateInfo: Dispatch<SetStateAction<Models.RateMap>>
  // (data: Models.RateMap) => void
  alreadyRatedMap: Record<keyof Models.RateMap, boolean>
  changeAlreadyRatedMap: (k: keyof Models.RateMap) => void
  unfinishedRateBtn: Array<keyof Models.RateMap>
}>({
  showProfessorPanel: () => {},
  professorRateInfo: {},
  changeProfessorRateInfo: () => {},
  alreadyRatedMap: {} as any,
  changeAlreadyRatedMap: () => {},
  unfinishedRateBtn: [],
})
